var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-icon"},[_c('figure',[_vm._t("default")],2),(_vm.text)?_c('p',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.text),expression:"text"}]}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }